module.exports = __webpack_public_path__ + "static/media/img-devteam-page@3x.b450069a.png";